<template>
  <div>
    <v-autocomplete
      :loading="isLoading"
      :items="items"
      :search-input.sync="search"
      flat
      clearable
      no-filter
      v-model="set"
      :disabled="disabled"
      item-text="name"
      item-value="id"
      :item-disabled="isDisabled"
      :label="label"
      :rules="rules"
      :return-object="true"
    >
      <template v-slot:selection="data">
        <i class="availability" v-bind:class="getAvailabiltyClass(data.item)"></i>
        {{ data.item.name }}
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar>
          <i class="availability" v-bind:class="getAvailabiltyClass(data.item)"></i>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{data.item.name}}</v-list-item-title>
          <v-list-item-subtitle>full set available: {{ getFullSetAvailability(data.item) }} | {{getAvailabiltyClass(data.item)}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-chip  v-if="isDisabled(data.item)" color="grey" text x-small class="ml-2" dark>{{'At least one product is inactive'}}</v-chip>
        </v-list-item-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      set: null,
      model: [],
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      search: null,
      isLoading: false,
      items: [],
      searchFilters: this.filters
    };
  },
  props: {
    value: {
      type: Object
    },
    label: {
      type: String
    },
    filters: {
      type: Object
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean
    }
  },
  watch: {
    /*value(){
            this.search = this.value;
            this.model = this.value;
        },*/
    search: {
      handler: _.debounce(function() {
        this.getProducts();
      }, 400)
    },
    filters: {
      handler: _.debounce(function() {
        if (this.filters) {
          this.searchFilters = this.filters;
          this.getProducts();
        }
      }, 400)
    },
    set() {
      this.$emit("input", this.set);
    }
  },
  mounted: function() {
    if (this.searchFilters) {
      this.getProducts();
    }
  },
  methods: {
    isDisabled(set) {
      let productDisabled = set.products.find(p => p.status == 'inactive');
      return productDisabled;
    },
    getFullSetAvailability(productSet){
      let min = 9999;
      for (let idx = 0; idx < productSet.products.length; idx++) {
        const product = productSet.products[idx];
        min = product.available < min ? product.available:min
      }
      return min > 0 ? min : 0
    },
    getAvailabiltyClass(productSet) {
      let productsAvailable = false;
      let fullset = true;

      for (let idx = 0; idx < productSet.products.length; idx++) {
        const product = productSet.products[idx];
        if(product.available > 1) {
          productsAvailable = true
        }else{
          fullset = false
        }
      }

      if(fullset) { return 'full'}
      if(productsAvailable) { return 'partially'}

      return 'missing'

    },
    getProducts() {
      if (this.set) return true;
      if (this.disabled) return true;
      this.isLoading = true;
      this.$store
        .dispatch("productSets/index", {
          search: this.search,
          filter: this.searchFilters,
          expand: "ironTypes"
        })
        .then(({sets}) => {
          this.items = sets.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style lang="less" scoped>
.availability {
  display: block;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: red;
  margin-right: 1rem;
  &.full {
    background-color: green;
  }
  &.partially {
    background-color: rgb(255, 136, 0);
  }
}
</style>
